import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAmenities, IAmenitiesInitialState } from "./amenitiesModal";
import {
  ActiveInactiveAmenities,
  createAmenities,
  deleteAmenities,
  AmenitiesImageUpload,
  getAllActiveAmenities,
  getAllAmenities,
  getAmenitiesByID,
  updateAmenities,
} from "./services/amenities.service";

const initialState: IAmenitiesInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  AmenitiesID: null,
  AmenitiesList: [],
  AmenitiesDetail: {
    ID: null,
    Title: "",
    Description: "",
    SequenceNo: null,
    Image: "",
    IsActive: 1,
  },
};

const amenitiesSlice = createSlice({
  name: "amenities",
  initialState,
  reducers: {
    clearAmenitiesDetails: (state) => {
      state.AmenitiesDetail = initialState.AmenitiesDetail;
    },
    setAmenitiesID: (state, action) => {
      state.AmenitiesID = action.payload;
    },
    clearAmenitiesID: (state) => {
      state.AmenitiesID = initialState.AmenitiesID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllAmenities.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllAmenities.fulfilled,
      (state, action: PayloadAction<IAmenities[]>) => {
        state.loading = false;
        state.AmenitiesList = action.payload || [];
      },
    );
    builder.addCase(getAllAmenities.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AmenitiesList = [];
    });
    builder.addCase(createAmenities.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createAmenities.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createAmenities.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateAmenities.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateAmenities.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateAmenities.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteAmenities.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteAmenities.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteAmenities.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAmenitiesByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getAmenitiesByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.AmenitiesDetail = action.payload;
    });
    builder.addCase(getAmenitiesByID.rejected, (state, action) => {
      state.formLoading = false;
      state.AmenitiesDetail = initialState.AmenitiesDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveAmenities.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveAmenities.fulfilled,
      (state, action: PayloadAction<IAmenities[]>) => {
        state.loading = false;
        state.AmenitiesList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveAmenities.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AmenitiesList = [];
    });
    builder.addCase(ActiveInactiveAmenities.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveAmenities.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveAmenities.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(AmenitiesImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(AmenitiesImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(AmenitiesImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearAmenitiesDetails, clearAmenitiesID, setAmenitiesID } =
  amenitiesSlice.actions;
export default amenitiesSlice.reducer;
